import { LazyLoad } from 'app/utils';

export const ShopCategorySortPage = LazyLoad(() => import('./index'), (module) => module.ShopCategorySortPage);
